// eslint-disable-next-line import/prefer-default-export
export const EP_STATUS = {
	SETTLED: 'SETTLED',
	SETTLING: 'SETTLING',
	VOIDED: 'VOIDED',
	SUBMITTED_FOR_SETTLEMENT: 'SUBMITTED_FOR_SETTLEMENT',
};
